import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { api, API_BASE } from "../api/client";
import { useSession } from "../lib/session";

const LABEL: Record<string, string> = { google: "Continue with Google", github: "Continue with GitHub" };

export function SignInSheet() {
  const { signInOpen, closeSignIn, providers, refresh, bump } = useSession();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  if (!signInOpen) return null;

  const next = encodeURIComponent(window.location.pathname + window.location.search);
  const devLogin = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await api.devLogin(email, email.split("@")[0] ?? "Reader");
      await refresh();
      bump();
      closeSignIn();
    } catch (err) {
      setError((err as Error).message);
    }
  };

  return (
    <>
      <div className="scrim" onClick={closeSignIn} />
      <div className="sheet" role="dialog" aria-modal="true" aria-label="Sign in">
        <div className="grab" />
        <h2 className="h-small">Sign in to save terms and join the discussion</h2>
        <p className="plain small">
          We keep your name and email from the account you choose, plus the terms you save. By continuing
          you confirm you are 16 or older and accept the <Link to="/privacy" onClick={closeSignIn}>privacy page</Link>.
          You can download or delete everything from the You tab at any time.
        </p>
        <div className="stack">
          {providers
            .filter((p) => p !== "dev")
            .map((p) => (
              <a key={p} className="btn" href={`${API_BASE}/auth/${p}/login?next=${next}`}>
                {LABEL[p] ?? p}
              </a>
            ))}
          {providers.filter((p) => p !== "dev").length === 0 && (
            <p className="mono">No sign-in provider is configured on this server yet.</p>
          )}
          {providers.includes("dev") && (
            <form className="stack" onSubmit={devLogin}>
              <span className="mono">DEVELOPMENT ONLY</span>
              <input
                type="email"
                required
                placeholder="any email address"
                aria-label="Email address (development sign-in)"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <button className="btn ghost" type="submit">
                Sign in without a password
              </button>
              {error && <span className="mono">{error}</span>}
            </form>
          )}
        </div>
      </div>
    </>
  );
}
